module.exports = __webpack_public_path__ + "img/img (4).f9c3de78.jpg";